export default __webpack_public_path__ + "static/bg-574f99015c479015e48d80f3f4da67f5.png";